interface TitleProps {
    title: string;
    subTitle: string;
}

function Title(props: TitleProps) {
    const { title, subTitle } = props;
    return (<div className="flex flex-col items-center text-center">
        <h2 className="text-dark font-bold text-[36px] lg:text-[38px] max-w-full mx-auto text-center">{title}</h2>
        <span className="border-b border-[2px] border-secondary w-[80px] inline-block mt-[10px]"></span>
        <p className="text-sub_title max-w-full mx-auto mt-[20px] text-[16px]">{subTitle}</p>
    </div>);
}

export default Title;